import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

export interface RateConfigContextType {
  isOpen: boolean;
  openRateConfig: () => void;
  closeRateConfig: () => void;
}

const RateConfigContext = createContext<RateConfigContextType | undefined>(undefined);

export function useRateConfig(): RateConfigContextType {
  const ctx = useContext(RateConfigContext);
  if (!ctx) {
    throw new Error('useRateConfig must be used within RateConfigProvider');
  }
  return ctx;
}

interface RateConfigProviderProps {
  children: ReactNode;
}

export function RateConfigProvider({ children }: RateConfigProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const openRateConfig = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeRateConfig = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value: RateConfigContextType = {
    isOpen,
    openRateConfig,
    closeRateConfig
  };

  return (
    <RateConfigContext.Provider value={value}>
      {children}
    </RateConfigContext.Provider>
  );
}
